module.exports = __webpack_public_path__ + "img/tour-30.6d7b1dca.png";